<template>
  <div>
    <div class="main_publish">
      <div class="publish-box">
        <div class="publish-head">
          <img class="head-img" src="../../assets/jnt/jntpic.jpg" />
        </div>
        <div class="publish-ul">
          <div class="publish-row">
            <div class="row-title"><span class="co-red">*</span>纪念馆类型：</div>
            <div class="row-mid flex">
              <div
                @click="qiehuan('danren')"
                :class="danren ? 'pub-radio pub-radio-selected' : 'pub-radio pub-radio-select'"
              >
                <div class="txt">单人馆</div>
              </div>
              <div
                @click="qiehuan('shuangren')"
                :class="!danren ? 'pub-radio pub-radio-selected' : 'pub-radio pub-radio-select'"
              >
                <div class="txt">双人馆</div>
              </div>
            </div>
          </div>
          <div class="publish-row">
            <div class="row-title"><span class="co-red">*</span>逝者姓名：</div>
            <div class="row-mid">
              <input
                type="text"
                maxlength="10"
                v-model="formData.firstName"
                class="input-name"
                placeholder="填写逝者姓名"
              />
            </div>
          </div>
          <div class="uploader-img">
            <van-uploader
              :before-read="beforeFirstRead" 
              :after-read="afterFirstRead" />
            <img
              :src="formData.firstPhoto"
              v-if="formData.firstPhoto"
              alt="图片"
              class="imgPreview"
              style="width:80px;height:80px;float:left;background-color:#ff0000;"
            />
          </div>
          <div class="publish-row">
            <div class="row-title">出生日期：</div>
            <div class="row-mid right-arrow">
              <input
                type="text"
                class="input-name"
                readonly=""
                placeholder="选择日期"
                v-model="formData.firstBirthDate"
                @click="showFirstBirth = true"
              />
              <van-popup v-model="showFirstBirth" position="bottom" :style="{ height: '50%' }">
                <van-datetime-picker
                  v-model="firstCurrentDateBirth"
                  type="date"
                  title="选择年月日"
                  :min-date="minDate"
                  :max-date="maxDate"
                  @confirm="onConfirmFirstBirth"
                  @cancel="cancelConfirmFirstBirth"
                />
              </van-popup>
              <!-- <van-calendar v-model="showFirstBirth" @confirm="onConfirmFirstBirth" /> -->
            </div>
          </div>
          <div class="publish-row">
            <div class="row-title">逝世日期：</div>
            <div class="row-mid right-arrow">
              <input
                type="text"
                class="input-name"
                readonly=""
                placeholder="选择日期"
                v-model="formData.firstDeathDate"
                @click="showFirstDeath = true"
              />
              <van-popup v-model="showFirstDeath" position="bottom" :style="{ height: '50%' }">
                <van-datetime-picker
                  v-model="firstCurrentDateDeath"
                  type="date"
                  title="选择年月日"
                  :min-date="minDate"
                  :max-date="maxDate"
                  @confirm="onConfirmFirstDeath"
                  @cancel="cancelConfirmFirstDeath"
                />
              </van-popup>
              <!-- <van-calendar v-model="showFirstDeath" @confirm="onConfirmFirstDeath" /> -->
            </div>
          </div>
        </div>
        <div v-if="!danren" class="publish-ul row-top10">
          <div class="publish-row">
            <div class="row-title"><span class="co-red">*</span>逝者姓名：</div>
            <div class="row-mid">
              <input
                v-model="formData.secondName"
                type="text"
                maxlength="10"
                class="input-name"
                placeholder="填写逝者姓名"
              />
            </div>
          </div>
          <div class="uploader-img">
            <van-uploader 
              :before-read="beforeSecondRead"
              :after-read="afterSecondRead" />
            <img
              v-if="formData.secondPhoto"
              :src="formData.secondPhoto"
              alt="图片"
              class="imgPreview"
              style="width:80px;height:80px;float:left;background-color:#ff0000;"
            />
          </div>

          <div class="publish-row">
            <div class="row-title">出生日期：</div>

            <div class="row-mid right-arrow">
              <input
                type="text"
                class="input-name"
                readonly=""
                placeholder="选择日期"
                v-model="formData.secondBirthDate"
                @click="showSecondBirth = true"
              />
              <van-popup v-model="showSecondBirth" position="bottom" :style="{ height: '50%' }">
                <van-datetime-picker
                  v-model="secondCurrentDateBirth"
                  type="date"
                  title="选择年月日"
                  :min-date="minDate"
                  :max-date="maxDate"
                  @confirm="onConfirmSecondBirth"
                  @cancel="cancelConfirmSecondBirth"
                />
              </van-popup>
            </div>
          </div>
          <div class="publish-row">
            <div class="row-title">逝世日期：</div>
            <div class="row-mid right-arrow">
              <input
                type="text"
                class="input-name"
                readonly=""
                placeholder="选择日期"
                v-model="formData.secondDeathDate"
                @click="showSecondDeath = true"
              />
              <van-popup v-model="showSecondDeath" position="bottom" :style="{ height: '50%' }">
                <van-datetime-picker
                  v-model="secondCurrentDateDeath"
                  type="date"
                  title="选择年月日"
                  :min-date="minDate"
                  :max-date="maxDate"
                  @confirm="onConfirmSecondDeath"
                  @cancel="cancelConfirmSecondDeath"
                />
              </van-popup>
              <!-- <van-calendar v-model="showSecondDeath" @confirm="onConfirmSecondDeath" /> -->
            </div>
          </div>
        </div>
        <div class="publish-ul">
          <div class="publish-row">
            <div class="row-title">逝者生平：</div>
            <div class="row-mid right-arrow"></div>
          </div>
          <div class="publish-content">
            <textarea
              rows="5"
              v-model="formData.content"
              placeholder="填写逝者的生平事迹，让后人、亲友能够留传和纪念..."
            ></textarea>
          </div>
        </div>
        <div class="publish-footer-remind">
          注：请勿发布不良信息，和谐、友好的环境需要我们共同维护。
        </div>
        <div class="publish-submit" @click="submitHall()">
          <p class="btn bg-orange"><i class="icon-quick"></i><span>快速创建纪念馆</span></p>
        </div>
      </div>
      <a
        id="mt-datetime-rpm06"
        class="mt-datetime weui-cell weui-cell_access"
        href="javascript:;"
        style="display: none;"
        ><div class="weui-cell__hd"></div>
        <div class="weui-cell__ft mt-cell-primary mt-datetime-value"></div></a
      ><a
        id="mt-datetime-fqtic"
        class="mt-datetime weui-cell weui-cell_access"
        href="javascript:;"
        style="display: none;"
        ><div class="weui-cell__hd"></div>
        <div class="weui-cell__ft mt-cell-primary mt-datetime-value"></div
      ></a>
      <div>
        <section class="footDiv foot1">
          <section class="bottomMenu" style="">
            <section @click="menuClick(0)" class="menuList">
              <i class="iconfont">&#xe70c;</i>
              <span>商城</span>
            </section>
            <section @click="menuClick(1)" class="menuList">
              <i class="iconfont">&#xe8aa;</i>
              <span>服务</span>
            </section>
            <section @click="menuClick(3)" class="menuList active">
              <i class="iconfont">&#xe670;</i>
              <span>纪念堂</span>
            </section>
            <section @click="menuClick(2)" class="menuList">
              <i class="iconfont">&#xe600;</i>
              <span>我的</span>
            </section>
          </section>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import * as imageConversion from 'image-conversion'
var currentYear = new Date().getFullYear()
var currentDate = new Date(currentYear, 0, 1)
export default {
  name: 'agreement',
  data() {
    return {
      firstCurrentDateBirth: currentDate,
      firstCurrentDateDeath: currentDate,
      secondCurrentDateBirth: currentDate,
      secondCurrentDateDeath: currentDate,
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(2025, 10, 1),
      show: false,
      danren: true,
      showFirstBirth: false,
      showFirstDeath: false,
      showSecondBirth: false,
      showSecondDeath: false,
      formData: {
        myId: this.$store.getters.userId,
        category: 'siren',
        hallCount: '1',
        firstPhoto: null,
        firstName: null,
        firstBirthDate: null,
        firstDeathDate: null,
        secondPhoto: null,
        secondName: null,
        secondBirthDate: null,
        secondDeathDate: null,
        content: null
      },
    }
  },
  beforeRouteEnter(to, from, next) {
    if (from.path.indexOf('jisao/detail') > -1) {
      localStorage.setItem('reload', 'true')
    } else {
      localStorage.removeItem('reload')
    }
    next()
  },
  created() {
    if (localStorage.getItem('reload')) {
      location.reload()
    }
  },
  methods: {
    menuClick(id) {
      if (id == 0) {
        this.$router.push({ path: '/shop' })
      } else if (id == 1) {
        this.$router.push({ path: '/shop/services' })
      } else if (id == 2) {
        this.$router.push({ path: '/my' })
      } else if (id == 3) {
        this.$router.push({ path: '/jnt' })
      }
    },
    clickMenuItem: function(item) {
      //item
      if (item.path) {
        this.$router.push({ path: '/jnt/list/' + item.path })
      } else {
        this.$router.push({ path: '/jnt' })
      }
      console.log(item)
    },
    submitHall() {
      let that = this
      this.$submit('/api/hall/addHall', this.formData, function(res) {
        if (res['code'] === 1) {
          that.$toast.success('纪念馆创建成功！')
          that.$router.push({ path: '/jnt/mourn/siren/' + res.id })
        }
      })
    },
    qiehuan(str) {
      if (str == 'danren') {
        this.danren = true
        this.formData.hallCount = '1'
      } else {
        this.danren = false
        this.formData.hallCount = '2'
      }
    },
    formatDate(predate) {
      return `${predate.getFullYear()}-${predate.getMonth() + 1}-${predate.getDate()}`
    },
    async beforeFirstRead(file){
      const MAX_SIZE = 300
      if(file.size > (MAX_SIZE+20)*1024){
        return new Promise((resolve, reject) =>{
          imageConversion.compressAccurately(file, MAX_SIZE).then((res) => {
            res = new File([res], file.name);
            resolve(res);
          });
          console.log(reject)
        })
      } else {
        return file
      }
    },
    afterFirstRead(file) {
      var that = this
      this.$upload('MemHall', file, function(res) {
        that.formData.firstPhoto = res['data']['url']
      })
    },
    async beforeSecondRead(file){
      const MAX_SIZE = 300
      if(file.size > (MAX_SIZE+20)*1024){
        return new Promise((resolve, reject) =>{
          imageConversion.compressAccurately(file, MAX_SIZE).then((res) => {
            res = new File([res], file.name);
            resolve(res);
          });
          console.log(reject)
        })
      } else {
        return file
      }
    },
    afterSecondRead(file) {
      var that = this
      this.$upload('MemHall', file, function(res) {
        that.formData.secondPhoto = res['data']['url']
      })
    },
    onConfirmFirstBirth(predate) {
      this.showFirstBirth = false
      this.formData.firstBirthDate = this.formatDate(predate)
    },
    cancelConfirmFirstBirth() {
      this.showFirstBirth = false
    },
    onConfirmFirstDeath(predate) {
      this.showFirstDeath = false
      this.formData.firstDeathDate = this.formatDate(predate)
    },
    cancelConfirmFirstDeath() {
      this.showFirstDeath = false
    },
    onConfirmSecondBirth(predate) {
      this.showSecondBirth = false
      this.formData.secondBirthDate = this.formatDate(predate)
    },
    cancelConfirmSecondBirth() {
      this.showSecondBirth = false
    },
    onConfirmSecondDeath(predate) {
      this.showSecondDeath = false
      this.formData.secondDeathDate = this.formatDate(predate)
    },
    cancelConfirmSecondDeath() {
      this.showSecondDeath = false
    },
  },
  watch: {},
}
</script>

<style>
.bottomMenu {
  background-color: #fff;
  position: fixed;
  z-index: 100;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 5rem;
  display: flex;
  box-shadow: 0 -0.027rem 0.05333rem rgb(0 0 0 / 10%);
  padding: 0.5rem;
}
.bottomMenu .menuList {
  flex: 1;
  display: flex;
  text-align: center;
  flex-direction: column;
  align-items: center;
  font-size: 1.1rem;
}
.bottomMenu .menuList.active i {
  color: #dea767;
  font-size: 2.1rem;
}

.bottomMenu .menuList i {
  color: #4c4c4c;
  font-size: 2.1rem;
}

.bottomMenu .menuList .icon_style {
  width: 2.5rem;
  height: 2.5rem;
  margin-top: 0.6rem;
  fill: #ccc;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: contain;
}
.bottomMenu .menuList.active {
  font-size: 1.1rem;
  color: #323232;
}

.bottomMenu .menuList {
  font-size: 1.1rem;
  color: #999;
}
.main_publish {
  padding-bottom: 68px;
}

.publish-box .publish-head {
  height: 10.5rem;
}
.publish-box .publish-head .head-img {
  width: 100%;
  /* height: 100%; */
}

.publish-box .publish-ul {
  background: #fff;
  margin-top: 6vw;
}
.publish-box .publish-row {
  display: -webkit-flex;
  display: flex;
  -webkit-flex-flow: row nowrap;
  flex-flow: row nowrap;
  -webkit-align-items: center;
  align-items: center;
  padding: 0 15px;
  position: relative;
  height: 4rem;
  line-height: 4rem;
}
.publish-row .row-title {
  height: 30px;
  display: inline-block;
  font-size: 1.3rem;
  color: #333;
  letter-spacing: 0;
  line-height: 30px;
  width: 9.5rem;
}
.publish-row .row-title .co-red {
  color: #d53d1a;
}
.publish-row .row-mid {
  -webkit-flex: 1 1;
  flex: 1 1;
  position: relative;
}
.flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
}
.publish-box .pub-radio {
  position: relative;
}
.publish-box .pub-radio-select:before,
.publish-box .pub-radio-selected:before {
  content: '';
  width: 1.5rem;
  height: 1.5rem;
  display: block;
  position: absolute;
  top: 50%;
  left: 0;
  margin-top: -0.75rem;
}
.publish-box .pub-radio-select:before {
  background: url(../../assets/jnt/unchecked.png) no-repeat;
  background-size: 100% 100%;
}
*,
:after,
:before {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.publish-box .pub-radio .txt {
  font-size: 1.3rem;
  color: #333;
  padding-left: 2rem;
  margin-right: 2rem;
}
.publish-box .pub-radio {
  position: relative;
}
.publish-box .pub-radio-selected:before {
  background: url(../../assets/jnt/checked.png) no-repeat;
  background-size: 100% 100%;
}
.publish-row .row-mid .input-name {
  width: 100%;
  height: 30px;
  display: inline-block;
  outline: 0;
  border: 0;
  font-size: 1.3rem;
  line-height: 30px;
  color: #1b1c21;
  text-align: left;
}
input[type='button'],
input[type='search'],
input[type='submit'],
input[type='text'],
textarea {
  -webkit-appearance: none;
}
input,
textarea {
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}
button,
input,
select,
textarea {
  -webkit-appearance: none;
}
.publish-box .uploader-img {
  padding: 0 15px;
  margin-top: 10px;
  padding-bottom: 10px;
  position: relative;
  width: 200px;
  height: 80px;
  display: flex;
}
.weui-uploader__hd {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  padding-bottom: 10px;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.weui-uploader__title {
  font-size: 1.3rem;
  color: #1b1c21;
}
.weui-uploader__title {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}
.weui-uploader__info {
  color: #b2b2b2;
}
.weui-uploader__bd {
  margin-bottom: -4px;
  margin-right: -9px;
  overflow: hidden;
}
.weui-uploader__bd {
  margin-bottom: -4px;
  margin-right: -9px;
  overflow: normal;
  display: inline-block;
  width: 100%;
}
.weui-uploader__files {
  list-style: none;
}
.weui-uploader__input-box {
  background: #f6f6f6;
  border-radius: 5px;
  border: none !important;
}
.weui-uploader__input-box {
  float: left;
  position: relative;
  margin-right: 9px;
  margin-bottom: 9px;
  width: 77px;
  height: 77px;
  border: 1px solid #d9d9d9;
}
.weui-uploader__input-box:before {
  width: 2px;
  height: 39.5px;
}
.weui-uploader__input-box:after,
.weui-uploader__input-box:before {
  content: ' ';
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  background-color: #d9d9d9;
}
.weui-uploader__input-box:after {
  width: 39.5px;
  height: 2px;
}
.weui-uploader__input-box:after,
.weui-uploader__input-box:before {
  content: ' ';
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  background-color: #d9d9d9;
}
.weui-uploader__input {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.publish-box .uploader-img .uploader-tips {
  color: #999;
  font-size: 0.9rem;
  padding: 8px 0;
}
.publish-footer-remind {
  margin-top: 15px;
  font-size: 1.2rem;
  color: #999;
  padding: 0 15px;
  line-height: 24px;
}
.publish-submit {
  padding: 0 15px;
  margin-top: 20px;
  margin-bottom: 20px;
}
.publish-submit .btn {
  color: #fff;
  border-radius: 5px;
  width: 100%;
  height: 3.8rem;
  font-size: 1.45rem;
  line-height: 3.8rem;
  text-align: center;
}
.bg-orange {
  background: #e4803c;
}
.publish-submit .btn .icon-quick {
  background: url(../../assets/jnt/jta1.png) no-repeat;
  background-size: 100% 100%;
  height: 1.25rem;
  width: 1.1rem;
  display: inline-block;
  position: relative;
  top: -1px;
  margin-right: 5px;
}
.footer_layer,
.footer_layer_common,
.footer_layer_newyear {
  position: fixed;
  bottom: -1px;
  left: 0;
  z-index: 900;
  width: 100%;
  background: #fff;
  height: 4.525rem;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}
article,
aside,
footer,
header,
nav,
section {
  display: block;
}
.footer_layer .nav-bar,
.footer_layer_common .nav-bar,
.footer_layer_newyear .nav-bar {
  overflow: visible;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.linetop {
  width: 100%;
  display: -webkit-box;
  position: relative;
}
.linetop:before {
  content: '\20';
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;
  right: 0;
  border-top: 1px solid #eeeff3;
  -webkit-transform: scaleY(0.5);
  -webkit-transform-origin: 0 0;
}
.footer_layer .option,
.footer_layer_common .option,
.footer_layer_common .option-add,
.footer_layer_newyear .option {
  color: #666;
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  font-size: 0.995rem;
  text-align: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  position: relative;
}
a {
  text-decoration: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
a {
  background: transparent;
  text-decoration: none;
}
:focus,
a {
  outline: none;
}
.footer_layer a.option:first-of-type span.bg {
  background-image: url(../../assets/jnt/menu1-.png);
}
.footer_layer .option span.bg,
.footer_layer_common .option span.bg,
.footer_layer_newyear .option span.bg {
  display: block;
  height: 24px;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 24px 24px;
  margin-bottom: 0.2rem;
}
.footer_layer .option p.nav_word,
.footer_layer_common .option p.nav_word,
.footer_layer_newyear .option p.nav_word {
  margin: 0;
  margin-top: 0;
  padding: 0;
}
.footer_layer_common .option-add .btn-add,
.footer_layer_qingming .option-add .btn-add {
  display: block;
  width: 3.6rem;
  height: 3.6rem;
  line-height: 4.25rem;
  text-align: center;
  border-radius: 50%;
  border: 4px solid #fff;
  margin: 0 auto;
  margin-top: -2.5rem;
  box-shadow: 0 -2px 1px -1px #eeeff3;
  -ms-flex-align: center;
  -ms-flex-pack: center;
  -webkit-align-items: center;
  -webkit-justify-content: center;
  align-items: center;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}
.footer_layer_common .option-add .btn-add {
  background: #e4803c;
}
.footer_layer_common .option-add .btn-add .icon-add {
  background: url(../../assets/jnt/jia.png) no-repeat;
  background-size: 100% 100%;
  height: 1.7rem;
  width: 1.7rem;
  display: flex;
}
.footer_layer a.option-add span.active + p,
.footer_layer a.option:nth-of-type(3) span.active + p {
  color: #e4803c;
}
.footer_layer a.option:nth-of-type(3) span.bg {
  background-image: url(../../assets/jnt/menu2-.png);
}
.publish-content {
  border-radius: 5px;
  background-color: #fff;
  position: relative;
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 10px;
}
.publish-content textarea {
  padding: 15px;
  border: none;
  width: 100%;
  overflow-y: visible;
  resize: none;
  line-height: 1.6rem;
  height: 14.9rem;
  color: #000;
  font-size: 1.3rem;
  background: #f8f8f8;
  border-radius: 5px;
}
</style>
